import React, { useState } from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
  updateOpenModalCreateEditBank,
  updateBankRefreshTable,
  updateFormAction,
} from "../../../redux/banks/bankSlice";
import { FormAction } from "../../../types/enums";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";
// WIZARD COMPONENTS
import WizardExportButton from "../../setupWizard/components/WizardExportButton";
import WizardImportDialog from "../../setupWizard/components/WizardImportDialog";

function BanksHeader() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [importOpen, setImportOpen] = useState(false);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { globalOrganizationId } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleOpenModalCreateNewBank = () => {
    dispatch(updateOpenModalCreateEditBank(true));
    dispatch(updateFormAction(FormAction.Create));
  };

  const onClickRefreshPage = () => {
    dispatch(updateBankRefreshTable(true));
    setTimeout(() => {
      dispatch(updateBankRefreshTable(false));
    }, 1000);
  };

  const handleImportSuccess = () => {
    onClickRefreshPage();
  };

  return (
    <div>
      <div className="generalStyles__pageHeader">
        {hasPermission(Permission.BanksCreate, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              type="primary"
              icon={<FontAwesomeIcon icon={faPlus} className="generalStyles__mrFix" />}
              onClick={handleOpenModalCreateNewBank}
            >
              {t("edgeManagement.banks.createNewBank")}
            </Button>
          </div>
        )}
        {hasPermission(Permission.BanksView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              className="buttonStyle__8"
              icon={<FontAwesomeIcon icon={faArrowsRotate} className="generalStyles__mrFix" />}
              onClick={() => {
                onClickRefreshPage();
              }}
            >
              {t("edgeManagement.banks.refreshTable")}
            </Button>
          </div>
        )}
        {hasPermission(Permission.BanksView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <Button
              icon={<UploadOutlined />}
              onClick={() => setImportOpen(true)}
              disabled={!globalOrganizationId}
            >
              Import
            </Button>
          </div>
        )}
        {hasPermission(Permission.BanksView, permissionSet ?? []) && (
          <div className="generalStyles__mlFix mt-1">
            <WizardExportButton stage={4} orgId={globalOrganizationId || null} />
          </div>
        )}
      </div>
      {globalOrganizationId && (
        <WizardImportDialog
          orgId={globalOrganizationId}
          visible={importOpen}
          onClose={() => setImportOpen(false)}
          onSuccess={handleImportSuccess}
        />
      )}
    </div>
  );
}

export default BanksHeader;
